import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const BlueskyIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Bluesky</title>
      <path
        d="M20 18.4218C18.551 15.6479 14.6052 10.4784 10.9364 7.92885C7.42196 5.48652 6.08124 5.90969 5.20231 6.30064C4.18497 6.75316 4 8.29062 4 9.19518C4 10.0997 4.50378 16.6113 4.83237 17.6982C5.9181 21.2896 9.78314 22.5031 13.3426 22.1136C13.5245 22.087 13.7091 22.0625 13.8959 22.0398C13.7126 22.0687 13.528 22.0933 13.3426 22.1136C8.12626 22.8741 3.49367 24.7454 9.56962 31.4039C16.2532 38.2157 18.7293 29.9432 20 25.7489C21.2707 29.9432 22.7342 37.9174 30.3107 31.4039C36 25.7489 31.8738 22.8744 26.6574 22.1138C26.472 22.0935 26.2874 22.0689 26.1041 22.0401C26.2909 22.0627 26.4755 22.0873 26.6574 22.1138C30.2169 22.5034 34.0819 21.2897 35.1676 17.6985C35.4963 16.6116 36 10.1 36 9.19541C36 8.29085 35.815 6.75339 34.7977 6.30087C33.9188 5.90992 32.578 5.48675 29.0636 7.92908C25.3948 10.4786 21.449 15.6479 20 18.4218Z"
        fill={fill}
      />
    </svg>
  );
};

export default BlueskyIcon;
